var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-img"},[_c('h3',{staticClass:"validation-msg-mobile",style:({ margin: _vm.marginData })},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }